import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/sustainability/importer/sustainabilityImporterActions';

export default importerReducers(actions);
